import { FC, Fragment } from "react";

interface VCpuReservationCellProps {
  data: number;
}

export const VCpuReservationCell: FC<VCpuReservationCellProps> = ({ data }) => {
  return <Fragment>{data} vCPU</Fragment>;
};
